//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'A_G',
  data() {
    return {
      form: {
        item1: '',
        item2: '',
      },
      hasScore: false,
      disabled: false
    }
  },
  created() {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          console.log('form', form);
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      console.log('flag', flag);
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        let result = form.item1 / form.item2
        self.hasScore = true
        return String(result.toFixed(1))
      }
    }
  },


}



// WEBPACK FOOTER //
// ./src/pages/formulas/NewFormulas/A_G.vue